export default "__VITE_ASSET__DGt_mH_O__"